/* eslint-disable eslint-comments/no-unlimited-disable */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import UserService from '../../services/User.service';
import type { UserInformation } from '../../types/user.types';
import type { RootState } from '../store';
import { initialUserInformation } from './initialState';

const initialState: UserInformation = initialUserInformation;

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInformation: (state, action: PayloadAction<UserInformation>) => {
      /* eslint-disable */
      return action.payload;
      /* eslint-enable */
    },
  },
});

export const { setUserInformation } = userSlice.actions;
export const selectUserInformation = (state: RootState) => state.user;

export const loadUserInformation = async (dispatch: any) => {
  try {
    const response = await UserService.information();

    if (response.error) {
      throw new Error(response.message || 'Failed to fetch user information');
    }

    dispatch(setUserInformation(response.data));

    return response.data;
  } catch (error) {
    console.error('Error in loadUserInformation:', error);
    throw error;
  }
};
